import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { hdrm } from '@yola/ws-sdk';

const { DISABLE_BLUR_ATTR } = hdrm.constants.attributes;
const disableBlurAttribute = { [DISABLE_BLUR_ATTR]: true };

const defaultStyle = {};

const ResizeHandle = React.forwardRef(
  (
    {
      size = 'small',
      shape = 'circle',
      direction = 'top-bottom',
      left = 0,
      top = 0,
      className = null,
      style = defaultStyle,
      onMouseDown = Function.prototype,
      onMouseEnter = Function.prototype,
      onMouseLeave = Function.prototype,
      onTouchStart = null,
    },
    ref
  ) => {
    const classes = classNames(
      'ws-resize-handle',
      `ws-resize-handle--size-${size}`,
      `ws-resize-handle--shape-${shape}`,
      `ws-resize-handle--direction-${direction}`,
      className
    );

    return (
      <button
        className={classes}
        type="button"
        ref={ref}
        style={{
          left,
          top,
          ...style,
        }}
        onMouseDown={onMouseDown}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...(onTouchStart && { onTouchStart })}
        {...disableBlurAttribute}
      />
    );
  }
);

ResizeHandle.displayName = 'ResizeHandle';

ResizeHandle.propTypes = {
  shape: PropTypes.oneOf(['circle', 'oval']),
  size: PropTypes.oneOf(['small', 'large']),
  direction: PropTypes.oneOf([
    'top-bottom',
    'left-right',
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right',
    'all',
  ]),
  left: PropTypes.number,
  top: PropTypes.number,
  style: PropTypes.shape(),
  className: PropTypes.string,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onTouchStart: PropTypes.func,
};

export default ResizeHandle;
